import { API_URL } from "../constants";
import { getHeaders } from "../utils";

export const getImageUploadParams = async () => {
  const response = await fetch(`${API_URL}/api/image-upload-parameters`, {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};

export const addImage = async (uploadUrl, data) => {
  const response = await fetch(uploadUrl, {
    method: "POST",
    body: data,
  });

  let text = "";
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  const push = ({ value, done }) => {
    if (done) return text;
    text += decoder.decode(value, { stream: true });
    return reader.read().then(push);
  };

  return reader.read().then(push);
};
